import { formatDuration, formatNumber, formatPercent, truncatePath } from "./formatters";

const LandingPagesTable = ({ landingPages = [] }) => (
  <div className="bg-surface-container-low rounded-2xl p-6 border border-surface-container-high">
    <h3 className="font-headline text-base font-bold mb-4">Top Landing Pages</h3>
    {landingPages.length === 0 ? (
      <p className="text-sm text-on-surface-variant">No landing pages recorded in this period.</p>
    ) : (
      // Scrolls both ways: horizontally so narrow viewports keep every column, and
      // vertically (capped height) so a full 10-row table doesn't dominate the page.
      <div className="overflow-auto max-h-72 pr-2">
        <table className="w-full text-sm min-w-[560px]">
          <thead>
            <tr className="text-left text-xs uppercase tracking-wide text-on-surface-variant sticky top-0 z-10 bg-surface-container-low">
              <th className="pb-3 font-semibold">Landing page</th>
              <th className="pb-3 font-semibold text-right">Sessions</th>
              <th className="pb-3 font-semibold text-right">Bounce rate</th>
              <th className="pb-3 font-semibold text-right">Avg engagement</th>
              <th className="pb-3 font-semibold text-right">Conversions</th>
            </tr>
          </thead>
          <tbody>
            {landingPages.map((row) => (
              <tr key={row.landing_page} className="border-t border-surface-container-high">
                <td className="py-3 pr-4 text-on-surface" title={row.landing_page}>
                  {truncatePath(row.landing_page)}
                </td>
                <td className="py-3 text-right text-on-surface">{formatNumber(row.sessions)}</td>
                <td className="py-3 text-right text-on-surface-variant">
                  {formatPercent(row.bounce_rate)}
                </td>
                <td className="py-3 text-right text-on-surface-variant">
                  {formatDuration(row.avg_engagement_seconds)}
                </td>
                <td className="py-3 text-right text-on-surface">{formatNumber(row.conversions)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);

export default LandingPagesTable;
